export default {
  banner: {
    title: 'We’ve updated our terms & conditions',
    content:
      'We now use Userback, a third-party feedback and bug-reporting tool. Any feedback you submit, along with data captured with it such as screenshots and page details, is processed by Userback on our behalf. By dismissing this message, you consent and agree to our updated ',
    link: 'EULA, Terms and conditions and Privacy Policy.',
    dismiss: 'Dismiss',
  },
};
